// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zWcV3","title":"styles_title__6nkNJ","rot":"styles_rot__BUjXX"};